// extracted by mini-css-extract-plugin
export default {"wrapper":"confirm_add_subject_wrapper__RGYoE","title":"confirm_add_subject_title__CLEsF","para":"confirm_add_subject_para__7BEQv","buttons":"confirm_add_subject_buttons__tXINR"};